import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import { getCustomerInfoRequest } from './info-actions';
import Info from '../components/info';

const mapStateToProps = state => ({
  customer: state.customer.info.data,
  payer: state.customer.info.payer,
  types: state.customer.info.types,
  isLoading: state.customer.info.isLoading,
  error: state.customer.info.error,
});

const mapDispatchToProps = {
  getCustomerInfoRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Info));
